<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <div class="container-fluid">
          <div class="row product-wrapper">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProductPresentation",
};
</script>
<style scoped>
.product-wrapper {
  padding: 20px 62px 0 62px;
}
</style>


// WEBPACK FOOTER //
// src/pages/productPresentation.vue